import { Injectable } from "@angular/core";
import { BaseEntityService } from "./rest-common.service";
import { HttpClient } from "@angular/common/http";
import { UserService } from "./user.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class AdsService extends BaseEntityService {
  public resource_url = `${this.BASE_CDP_URL}/ad-tag/`;
  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  macrosListing(){
    let url = `${this.BASE_CDP_URL}/ad-macros`;
    return this.get(url);
  }

  getAdsData(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/`, '', params);
    return this.get(url);
  }

  generateURL(id, params={}){
    let url = this.buildUrl(`${this.resource_url}${id}/tag-url/`, '', params)
    return this.get(url);
  }

}
